



















// Importing components
import BaseCardRestaurant from '@/ui/BaseCardRestaurant.vue';
import BaseSection from '@/ui/BaseSection.vue';

export default {
    name: 'TheWelcomeDonations',
    components: {
        BaseCardRestaurant,
        BaseSection,
    },
    props: {
        getData: {},
        restaurants: Array,
    },
};
